import { useState, useContext, useEffect } from "react";
import { Container, Card, Button, Row, Col } from "react-bootstrap";
import UserContext from "../UserContext";
import { useNavigate, useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { API_ENDPOINTS, getAuthHeaders } from "../config/api";

export default function ProductView() {
  const { user } = useContext(UserContext);

  const { productId } = useParams();

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0);

  useEffect(() => {
    console.log(productId);

    fetch(API_ENDPOINTS.PRODUCTS.GET_BY_ID(productId))
      .then((res) => res.json())
      .then((data) => {
        setName(data.name);
        setDescription(data.description);
        setPrice(data.price);
      });
  });

  const purchase = (productId) => {
    fetch(API_ENDPOINTS.ORDERS.CHECKOUT, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({
        productId: productId,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
  
        if (data.success) {
          Swal.fire({
            title: "Added to Cart",
            icon: "success",
            text: "Thank you!",
          });
  
          navigate("/products");
        } else {
          Swal.fire({
            title: "Something went wrong",
            icon: "error",
            text: data.message || "Please try again",
          });
        }
      })
      .catch((error) => {
        console.error("Error during purchase:", error);
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to connect to the server.",
        });
      });
  };
// addToCart function
  const addToCart = (productId) => {
    fetch(API_ENDPOINTS.ORDERS.ADD_TO_CART, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify({ productId }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          Swal.fire({
            title: "Added to Cart",
            icon: "success",
            text: "Product has been added to your cart.",
          });
        } else {
          Swal.fire({
            title: "Error",
            icon: "error",
            text: data.message || "Failed to add product to cart.",
          });
        }
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to connect to the server.",
        });
      });
  };
  
  return (
    <Container className="mt-5">
      <Row>
        <Col lg={{ span: 6, offset: 3 }}>
          <Card>
            <Card.Body className="text-center">
              <Card.Title>{name}</Card.Title>
              <Card.Subtitle>Description:</Card.Subtitle>
              <Card.Text>{description}</Card.Text>
              <Card.Subtitle>Price:</Card.Subtitle>
              <Card.Text>PhP {price}</Card.Text>
              <Card.Subtitle>Buy</Card.Subtitle>
              <Card.Text>Now!</Card.Text>
              {user.id !== null ? (
                <Button
                  variant="primary"
                  block
                  onClick={() => addToCart(productId)}
                >
                  Add to Cart
                </Button>
              ) : (
                <Link className="btn btn-danger btn-block" to="/login">
                  Login
                </Link>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
